/**
 * Generic Banner Feature Control Key
 * This is used for the banner that appears on the corporate account manager to sales manager page
 * It is a generic feature control key that can be used for any banner
 */
export const GENERIC_BANNER_CONFIG = "corporate_generic-banner_toggle";

export const PREBOOK_PRICE_CHANGE_BREAKDOWN_V2 =
  "booking_temp-prebook-price-change-breakdown-v2_toggle";

/**
 * S3 Feature Control Keys
 * These keys are used to fetch feature control data from S3
 */
export const s3FeatureControlKeys = [
  GENERIC_BANNER_CONFIG,
  PREBOOK_PRICE_CHANGE_BREAKDOWN_V2,
];
